import toast from 'react-hot-toast';
import entityRelationService from '../../services/entityRelationService';

export const confirmAnalysisSuggestions = async ({
  aiAnalysisResult,
  selectedSuggestions,
  fetchNoteRelations,
  t
}) => {
  if (!aiAnalysisResult || !aiAnalysisResult.noteId) {
    console.error('No analysis result or note ID found');
    return;
  }

  const noteId = aiAnalysisResult.noteId;
  const toLink = [];

  try {
    // Collect all selected entities to link
    Object.keys(selectedSuggestions).forEach(entityType => {
      selectedSuggestions[entityType].forEach(index => {
        const entities = aiAnalysisResult[entityType] || [];
        const entity = entities[index];
        
        if (!entity) return;
        
        // Get the appropriate ID field based on entity type
        let entityId = null;
        let capitalizedType = entityType.charAt(0).toUpperCase() + entityType.slice(0, -1); // Remove 's' and capitalize
        
        if (entityType === 'customers' && entity.customerId) {
          entityId = entity.customerId;
          capitalizedType = 'Customer';
        } else if (entityType === 'leads' && entity.leadId) {
          entityId = entity.leadId;
          capitalizedType = 'Lead';
        } else if (entityType === 'opportunities' && entity.opportunityId) {
          entityId = entity.opportunityId;
          capitalizedType = 'Opportunity';
        } else if (entityType === 'activities' && entity.activityId) {
          entityId = entity.activityId;
          capitalizedType = 'Activity';
        }
        
        if (entityId) {
          toLink.push({ type: capitalizedType, id: entityId });
        }
      });
    });

    if (toLink.length === 0) {
      toast.info(t('Notes.noSuggestionsSelected') || 'No suggestions selected');
      return { success: false, message: 'No suggestions selected' };
    }

    // Create relations for selected suggestions
    const results = await Promise.allSettled(
      toLink.map(ent => entityRelationService.create({
        sourceEntityType: 'SaleNote',
        sourceEntityID: noteId,
        targetEntityType: ent.type,
        targetEntityID: ent.id,
        relationType: 'related_to'
      }))
    );

    const successful = results.filter(r => r.status === 'fulfilled').length;
    const failed = results.filter(r => r.status === 'rejected').length;

    // Refresh note relations
    if (fetchNoteRelations) {
      await fetchNoteRelations(noteId);
    }

    // Show success message
    if (failed === 0) {
      toast.success(
        t('Notes.relationsCreatedSuccessfully') || 
        `Successfully linked ${successful} ${successful === 1 ? 'entity' : 'entities'}`
      );
    } else {
      toast.warning(
        t('Notes.relationsPartialSuccess') || 
        `Linked ${successful} entities, ${failed} failed`
      );
    }

    return { success: true, successful, failed };
  } catch (error) {
    console.error('Error confirming suggestions:', error);
    toast.error(t('Notes.failedToCreateRelations') || 'Failed to create relations');
    return { success: false, error };
  }
};

// Helper function to get entity route based on type
export const getEntityRoute = (type, id) => {
  // Handle undefined or null IDs
  if (!id || id === 'undefined' || id === 'null') {
    return '#';
  }
  
  switch (type) {
    case 'customer':
      return `/customers/${id}`;
    case 'lead':
      return `/leads/${id}`;
    case 'opportunity':
      return `/opportunities/${id}`;
    case 'activity':
      return `/activities?activityId=${id}`;
    default:
      return '#';
  }
};
